import axios from "axios";

export default axios.create({
  baseURL: process.env.VUE_APP_POSTCODE_JP_API_BASS_URL,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
  responseType: "json",
});
